<template>
  <div class="header-container">
    <div v-if="currentPage == 1" class="text-container">
      <h2>create the now</h2>
      <p>Auf geht’s: Wähle die Icons und den Text aus, die du für dein Design verwenden möchtest. Danach kannst Du die Größe skalieren und die Position auf deiner Hülle festlegen. 
<br /><b>Tob dich aus!</b></p>
    </div>
    <div v-else-if="currentPage == 2" class="text-container">
      <h2>SO SIEHT'S AUS!</h2>
      <p>Das ist dein Design. Alles schick?
Oder willst du noch was ändern?
Klick einfach den entsprechenden Button.</p>
    </div>
    <div v-else-if="currentPage == 3" class="text-container">
      <h2>create the now</h2>
          <p>Fast fertig. Verrate uns nur noch, für wen das Feuerzeug
    ist und dann komm zu unserem Stand und hol dir
    Dein Designerstück ab!
    </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Head",
  props: ['currentPage'],
  methods: {
    onClickButton () {
      this.$emit('start')
    }
  }
}
</script>
<style lang="scss" scoped>
.header-container {
  display: flex;
  padding-top: 80px;

  .text-container {
    h2 {
      margin-bottom: 20px;
      color: #00B7E5;
      font-size: 40px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 25px;
    }

    p {
      margin: 0;
      max-width: 443px;
      font-family: 'Graphik';
      font-size: 18px;
      line-height: 25px;
      color: #003C71;
    }
  }
}

</style>
